import type { CategoryTypes } from '../types';

export const shouldRenderSubMenu = (subMenu: CategoryTypes, type: CategoryTypes['type']) => {
    if (type === ('card' as CategoryTypes['type'])) {
        if (!subMenu?.cards) {
            return false;
        }
        return subMenu?.cards?.length > 0;
    }

    return true;
};
